import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @closeModal={{@closeModal}}
  @title={{i18n "directory.edit_columns.title"}}
  class="edit-user-directory-columns-modal"
  @flash={{this.flash}}
>
  <:body>
    {{#if this.loading}}
      {{loading-spinner size="large"}}
    {{else}}
      <div class="edit-directory-columns-container">
        {{#each this.columns as |column|}}
          <div class="edit-directory-column">
            <div class="left-content">
              <label class="column-name">
                <Input @type="checkbox" @checked={{column.enabled}} />
                {{#if (directory-column-is-automatic column=column)}}
                  {{directory-table-header-title
                    field=column.name
                    labelKey=this.labelKey
                    icon=column.icon
                  }}
                {{else if (directory-column-is-user-field column=column)}}
                  {{directory-table-header-title
                    field=column.user_field.name
                    translated=true
                  }}
                {{else}}
                  {{directory-table-header-title
                    field=(i18n column.name)
                    translated=true
                  }}
                {{/if}}
              </label>
            </div>
            <div class="right-content">
              <DButton
                @icon="arrow-up"
                @action={{fn this.moveUp column}}
                class="button-secondary move-column-up"
              />
              <DButton
                @icon="arrow-down"
                @action={{fn this.moveDown column}}
                class="button-secondary"
              />
            </div>
          </div>
        {{/each}}
      </div>
    {{/if}}
  </:body>
  <:footer>
    <DButton
      @label="directory.edit_columns.save"
      @action={{this.save}}
      class="btn-primary"
    />
    <DButton
      @label="directory.edit_columns.reset_to_default"
      @action={{this.resetToDefault}}
      class="btn-secondary reset-to-default"
    />
  </:footer>
</DModal>
*/
{
  "id": "vyjjrRu0",
  "block": "[[[8,[39,0],[[24,0,\"edit-user-directory-columns-modal\"]],[[\"@closeModal\",\"@title\",\"@flash\"],[[30,1],[28,[37,1],[\"directory.edit_columns.title\"],null],[30,0,[\"flash\"]]]],[[\"body\",\"footer\"],[[[[1,\"\\n\"],[41,[30,0,[\"loading\"]],[[[1,\"      \"],[1,[28,[35,3],null,[[\"size\"],[\"large\"]]]],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"edit-directory-columns-container\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"columns\"]]],null]],null],null,[[[1,\"          \"],[10,0],[14,0,\"edit-directory-column\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"left-content\"],[12],[1,\"\\n              \"],[10,\"label\"],[14,0,\"column-name\"],[12],[1,\"\\n                \"],[8,[39,6],null,[[\"@type\",\"@checked\"],[\"checkbox\",[30,2,[\"enabled\"]]]],null],[1,\"\\n\"],[41,[28,[37,7],null,[[\"column\"],[[30,2]]]],[[[1,\"                  \"],[1,[28,[35,8],null,[[\"field\",\"labelKey\",\"icon\"],[[30,2,[\"name\"]],[30,0,[\"labelKey\"]],[30,2,[\"icon\"]]]]]],[1,\"\\n\"]],[]],[[[41,[28,[37,9],null,[[\"column\"],[[30,2]]]],[[[1,\"                  \"],[1,[28,[35,8],null,[[\"field\",\"translated\"],[[30,2,[\"user_field\",\"name\"]],true]]]],[1,\"\\n\"]],[]],[[[1,\"                  \"],[1,[28,[35,8],null,[[\"field\",\"translated\"],[[28,[37,1],[[30,2,[\"name\"]]],null],true]]]],[1,\"\\n                \"]],[]]]],[]]],[1,\"              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,0],[14,0,\"right-content\"],[12],[1,\"\\n              \"],[8,[39,10],[[24,0,\"button-secondary move-column-up\"]],[[\"@icon\",\"@action\"],[\"arrow-up\",[28,[37,11],[[30,0,[\"moveUp\"]],[30,2]],null]]],null],[1,\"\\n              \"],[8,[39,10],[[24,0,\"button-secondary\"]],[[\"@icon\",\"@action\"],[\"arrow-down\",[28,[37,11],[[30,0,[\"moveDown\"]],[30,2]],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[2]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"]],[]],[[[1,\"\\n    \"],[8,[39,10],[[24,0,\"btn-primary\"]],[[\"@label\",\"@action\"],[\"directory.edit_columns.save\",[30,0,[\"save\"]]]],null],[1,\"\\n    \"],[8,[39,10],[[24,0,\"btn-secondary reset-to-default\"]],[[\"@label\",\"@action\"],[\"directory.edit_columns.reset_to_default\",[30,0,[\"resetToDefault\"]]]],null],[1,\"\\n  \"]],[]]]]]],[\"@closeModal\",\"column\"],false,[\"d-modal\",\"i18n\",\"if\",\"loading-spinner\",\"each\",\"-track-array\",\"input\",\"directory-column-is-automatic\",\"directory-table-header-title\",\"directory-column-is-user-field\",\"d-button\",\"fn\"]]",
  "moduleName": "discourse/components/modal/edit-user-directory-columns.hbs",
  "isStrictMode": false
});